// extracted by mini-css-extract-plugin
module.exports = {"Songs":"Songs_Songs__2Tydq","link":"Songs_link__3CjK1","song":"Songs_song__1IWat","songTitle":"Songs_songTitle__1WQab","lImg":"Songs_lImg__2mY5a","wmg":"Songs_wmg__1w3T0"};